import { CircularProgress, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './StakingCardInputs.module.css';

interface StakingButtonAndInputProps {
  loading: boolean;
  stakeAmt: string;
  onChange: (value: string) => void;
  onClick: () => void;
  walletBal: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    loader: {
      color: 'white',
    },
  }),
);

const StakingButtonAndInput: React.FC<StakingButtonAndInputProps> = ({
  loading,
  stakeAmt,
  onChange,
  onClick,
  walletBal,
}: StakingButtonAndInputProps) => {
  const classes = useStyles();
  return (
    <form className={styles.inputContainer}>
      <div className="input-component">
        <input
          type="number"
          className={styles.stakeInput}
          placeholder="ENTER AMOUNT"
          value={stakeAmt}
          onChange={event => {
            onChange(event.target.value);
          }}
        />
      </div>
      <Button
        color={Colors.COLOR_SCHEME_2}
        className={styles.stakingButtonsMini}
        disabled={parseFloat(walletBal) < parseInt(stakeAmt, 10)}
        onClick={onClick}
      >
        {loading ? <CircularProgress className={classes.loader} /> : 'STAKE'}
      </Button>
    </form>
  );
};

interface UnStakingButtonAndInputProps {
  loading: boolean;
  unStakeAmt: string;
  onChange: (value: string) => void;
  onClick: () => void;
  starsStakedAmt: string;
}
const UnStakingButtonAndInput: React.FC<UnStakingButtonAndInputProps> = ({
  loading,
  unStakeAmt,
  onChange,
  onClick,
  starsStakedAmt,
}: UnStakingButtonAndInputProps) => {
  const classes = useStyles();

  const onMaxClick: React.FormEventHandler<HTMLButtonElement> = event => {
    event.preventDefault();

    onChange(starsStakedAmt);
  };

  return (
    <form className={styles.inputContainer}>
      <div className="input-component">
        <input
          type="number"
          className={styles.stakeInput}
          placeholder="ENTER AMOUNT"
          value={unStakeAmt}
          onChange={event => {
            onChange(event.target.value);
          }}
        />
      </div>
      <button
        className={`mr-2 ${
          starsStakedAmt === unStakeAmt ? 'opacity-50' : 'opacity-70 '
        }`}
        onClick={onMaxClick}
      >
        max
      </button>
      <Button
        color={Colors.COLOR_SCHEME_6}
        className={styles.stakingButtonsMini}
        disabled={parseFloat(starsStakedAmt) < parseInt(unStakeAmt, 10)}
        onClick={onClick}
      >
        {loading ? <CircularProgress className={classes.loader} /> : 'UNSTAKE'}
      </Button>
    </form>
  );
};

export const StakingCardButtons = ({
  loading,
  isApproved,
  isStaking,
  stakeAmt,
  stakeOnClick,
  handleApprove,
  walletBal,
  handleStakeAmtChange,
  handlePlaceStake,
}: {
  loading: boolean;
  isApproved: boolean;
  isStaking: boolean;
  stakeAmt: string;
  walletBal: string;
  stakeOnClick: () => void;
  handleApprove: () => void;
  handleStakeAmtChange: (value: string) => void;
  handlePlaceStake: () => void;
}) => {
  return (
    <>
      {isApproved &&
        (isStaking ? (
          <StakingButtonAndInput
            loading={loading}
            stakeAmt={stakeAmt}
            onChange={handleStakeAmtChange}
            onClick={handlePlaceStake}
            walletBal={walletBal}
          />
        ) : (
          <Button
            color={Colors.COLOR_SCHEME_2}
            className={styles.stakingButtons}
            onClick={stakeOnClick}
          >
            STAKE
          </Button>
        ))}
      {!isApproved && (
        <Button
          color={Colors.COLOR_SCHEME_2}
          className={styles.stakingButtons}
          onClick={handleApprove}
        >
          APPROVE
        </Button>
      )}
    </>
  );
};

export const UnStakingCardButtons = ({
  loading,
  isUnStaking,
  unStakeAmt,
  unStakeOnClick,
  starsStakedAmt,
  handleUnStakeAmtChange,
  handlePlaceUnStake,
}: {
  loading: boolean;
  isApproved: boolean;
  isUnStaking: boolean;
  unStakeAmt: string;
  starsStakedAmt: string;
  unStakeOnClick: () => void;
  handleUnStakeAmtChange: (value: string) => void;
  handlePlaceUnStake: () => void;
}) => {
  return (
    <>
      {isUnStaking ? (
        <UnStakingButtonAndInput
          loading={loading}
          unStakeAmt={unStakeAmt}
          onChange={handleUnStakeAmtChange}
          onClick={handlePlaceUnStake}
          starsStakedAmt={starsStakedAmt}
        />
      ) : (
        <Button
          color={Colors.COLOR_SCHEME_6}
          className={styles.stakingButtons}
          onClick={unStakeOnClick}
          disabled={parseFloat(starsStakedAmt) <= 0}
        >
          UNSTAKE
        </Button>
      )}
    </>
  );
};
